const LeadingParagraph = ({ children }) => {
  return (
    <div className="mx-auto mb-10 md:max-w-xl lg:mb-20 lg:max-w-4xl">
      <p className="md:text-center md:text-xl lg:text-2xl">{children}</p>
    </div>
  )
}
export default LeadingParagraph
